(ns quuppa.peweb.universalformat.universal-target
  (:require [clojure.string :as str]
            [quuppa.ui.form :as form]
            [reagent.core :as r]))

(def mode->ui-config
  {:File {:title       "File logging"
          :description "File logging output target configuration"}
   :UDP  {:title       "UDP Push"
          :description "UDP Push output target configuration"}
   :MQTT {:title       "MQTT Publisher"
          :description "MQTT Broker target configuration. Broker connection details."}
   :Websocket {:title "Websocket"
               :description "Websocket output target configuration"}
   :HTTPPost {:title "HTTP Post"}})

(defn target-row-content
  "Universal target row in 'Outputs' table.
  Function returns content to be displayed for given target."
  [{target-name :name :keys [ip MQTTAddress port folder formatName enabled target error]}]
  (if (and enabled (or (= target :MQTT) (= target :Websocket)))
    [:div
     (str "Publishing: " target-name " to address: " MQTTAddress " using format: " formatName)
     (when (and error (not (empty? error)))
       [:div.bg-danger.p-1.target-row-error error])]
    (str
      "Logging: "
      (str/join " "
                [target-name
                 (case target
                   :File (when enabled (str " to folder: " folder))
                   :UDP (str " to IP: " ip ":" port " using format: " formatName)
                   "")]))))

(defn mqtt-fields [{:keys [pending? qpe-dispatch ut site-plan-key control-type? site-resource-id]}]
  (let [mqtt-auth-type (:MQTTAuthType ut)
        basic-auth-type? (= mqtt-auth-type "basic")
        bearer-auth-type? (= mqtt-auth-type "bearer")
        target-id (:id ut)
        mqtt-scheme (:MQTTScheme ut)
        ws-server-scheme? (or (= mqtt-scheme "wss")
                              (= mqtt-scheme "ws"))
        mqtt-address-placeholder (if ws-server-scheme?
                                   "<hostname-or-ip>:<port>/<path>"
                                   "<hostname-or-ip>:<port>")
        tcp-scheme-or-ws-scheme? (or (= mqtt-scheme "ws")
                                     (= mqtt-scheme "tcp"))
        client-certificate-validation? (= (:certificate-validation ut) "client")
        upload-key-file (fn [file]
                          (when file
                            (let [renamed-file (js/File. #js [(-> file (.slice 0 (.-size file)))]
                                                         "client.key"
                                                         #js {:type (or (.-type file) "application/x-x509-ca-cert")})
                                  form-data (js/FormData.)]
                              (.append form-data "file" renamed-file)
                              (.append form-data "site-plan-key" site-plan-key)
                              (qpe-dispatch [:qpe/upload-file form-data]))))]
    [:<>
     [:div.mb-3
      [form/form-label "MQTT broker address *"]
      [form/form-control
       {:disabled    pending?
        :required true
        :placeholder mqtt-address-placeholder
        :default-value (or (:MQTTAddress ut) "")
        :on-change   #(qpe-dispatch [:qpe/universal-target-form-change :MQTTAddress (.. % -target -value)])}]
      [form/form-control-feedback {:type "invalid"} "Please provide the MQTT broker address and port"]]

     [:div.mb-3
      [form/form-label "Client ID"]
      [form/form-control
       {:disabled  pending?
        :default-value (or (:MQTTClientId ut) "")
        :on-change #(qpe-dispatch [:qpe/universal-target-form-change :MQTTClientId (.. % -target -value)])}]]

     [:div.mb-1
      [form/form-label "Topic Prefix"]
      [form/form-control
       {:disabled  pending?
        :default-value     (or (:MQTTTopicPrefix ut) "")
        :on-change #(qpe-dispatch [:qpe/universal-target-form-change :MQTTTopicPrefix (.. % -target -value)])}]]

     [:div.mb-3.d-flex
      [form/form-check {:class "mr-2"
                        :label "Retain last message"
                        :style   {:accent-color "initial"}
                        :checked (boolean (:retain ut))
                        :on-change #(qpe-dispatch [:qpe/universal-target-form-change :retain (.. % -target -checked)])}]]

     [:div.mb-3
      [form/form-label "Communication protocol *"]
      [form/form-select
       {:disabled  pending?
        :required  true
        :value     (or mqtt-scheme "")
        :on-change #(qpe-dispatch [:qpe/universal-target-form-change :MQTTScheme (.. % -target -value)])}
       (for [scheme ["tcp" "ssl/tls" "ws" "wss"]]
         [:option
          {:key scheme
           :value scheme}
          (str/upper-case scheme)])]
      [form/form-control-feedback {:type "invalid"} "Please provide the communication protocol"]]

     (when-not tcp-scheme-or-ws-scheme?
       [:div.mb-3
        [form/form-label "Certificate validation"]
        [form/form-select
         {:disabled  (or pending? control-type?)
          :required  true
          :value     (or (:certificate-validation ut) "")
          :on-change #(qpe-dispatch [:qpe/universal-target-form-change :certificate-validation (.. % -target -value)])}
         [:option
          {:key "server"
           :value "server"}
          "CA signed server"]
         [:option
          {:key "client"
           :value "client"}
          "CA signed client"]]])

     (when (and (not tcp-scheme-or-ws-scheme?)
                (nil? site-resource-id))
       [:div.mb-3
        [form/form-label "CA file (optional)"]
        [form/form-control
         {:type      "file"
          :disabled  (and (or pending? control-type?) (= (:certificate-validation ut) "server"))
          :on-change (fn [e]
                       (let [file (.. e -target -files (item 0))
                             renamed-file (js/File. #js [(-> file (.slice 0 (.-size file)))]
                                                    "ca.crt"
                                                    #js {:type (or (.-type file) "application/x-x509-ca-cert")})
                             form-data (js/FormData.)]
                         (.append form-data "file" renamed-file)
                         (.append form-data "site-plan-key" site-plan-key)
                         (qpe-dispatch [:qpe/upload-file form-data])))}]])

     (when (and client-certificate-validation?
                (nil? site-resource-id)
                (not tcp-scheme-or-ws-scheme?))
       [:<>
        [:div.mb-3
         [form/form-label "Client certificate file"]
         [form/form-control
          {:type      "file"
           :on-change (fn [e]
                        (let [file (.. e -target -files (item 0))
                              renamed-file (js/File. #js [(-> file (.slice 0 (.-size file)))]
                                                     "client.crt"
                                                     #js {:type (or (.-type file) "application/x-x509-ca-cert")})
                              form-data (js/FormData.)]
                          (.append form-data "file" renamed-file)
                          (.append form-data "site-plan-key" site-plan-key)
                          (qpe-dispatch [:qpe/upload-file form-data])))}]]
        [:div.mb-3
         [form/form-label "Client key file"]
         [form/form-control
          {:type      "file"
           :on-change (fn [e]
                        (let [file (.. e -target -files (item 0))]
                          (upload-key-file file)))}]]
        [:div.mb-1
         [form/form-label "Client key passphrase(optional)"]
         [form/form-control
          {:disabled  pending?
           :default-value     (or (:client-key-passphrase ut) "")
           :on-change (fn [e]
                        (let [passphrase (.. e -target -value)]
                          (qpe-dispatch [:qpe/universal-target-form-change :client-key-passphrase passphrase])))}]]])

     [:div.mb-3
      [form/form-label "Authentication method"]
      [form/form-select
       {:disabled  pending?
        :value     (or mqtt-auth-type "")
        :on-change #(qpe-dispatch [:qpe/universal-target-form-change :MQTTAuthType (.. % -target -value)])}
       [:option {:value "none" :key "none"} "None"]
       [:option {:value "basic" :key "basic"} "Username/password"]
       [:option {:value "bearer" :key "bearer"} "BEARER token"]]]
     (when basic-auth-type?
       [:div.mb-3
        [form/form-label "Username *"]
        [form/form-control
         {:disabled  pending?
          :required true
          :default-value (or (:MQTTUsername ut) "")
          :on-change #(qpe-dispatch [:qpe/universal-target-form-change :MQTTUsername (.. % -target -value)])}]
        [form/form-control-feedback {:type "invalid"} "Please provide the username"]])
     (when basic-auth-type?
       [:div.mb-3
        [form/form-label "Password (password is hidden after saving)"]
        [form/form-control
         {:type      "password"
          :disabled  pending?
          :default-value     (or (:MQTTPassword ut) "")
          :on-change #(qpe-dispatch [:qpe/universal-target-form-change :MQTTPassword (.. % -target -value)])}]])
     (when bearer-auth-type?
       [:div.mb-3
        [form/form-label "Token *"]
        [form/form-control
         {:disabled  pending?
          :required true
          :value     (or (:MQTTAuthToken ut) "")
          :on-change #(qpe-dispatch [:qpe/universal-target-form-change :MQTTAuthToken (.. % -target -value)])}]
        [form/form-control-feedback {:type "invalid"} "Please provide the token"]])

     (when (and control-type?
                (seq site-resource-id))
       [:div.mb-3
        [:span "You have uploaded files for this configuration. Would you like to delete it and upload again?"]
        [:button.btn.btn-outline-danger.w-100.mt-2
         {:disabled pending?
          :on-click (fn [_e]
                      (when (js/confirm "Are you sure?")
                        (qpe-dispatch [:qsm/delete-uploaded-cert-files target-id site-plan-key])))}
         "Delete uploaded files"]])]))

(defn udp-fields [pending? qpe-dispatch ut]
  [:<>
   [:div.mb-3
    [form/form-label "Target IP address *"]
    [form/form-control
     {:disabled  pending?
      :default-value (or (:ipAddress ut) "")
      :required true
      :on-change #(qpe-dispatch [:qpe/universal-target-form-change :ipAddress (.. % -target -value)])}]
    [form/form-control-feedback {:type "invalid"} "Please provide the target IP address"]]

   [:div.mb-3
    [form/form-label "Target IP port [1 - 65535] *"]
    [form/form-control
     {:disabled  pending?
      :type      "number"
      :required true
      :default-value (str (:port ut))
      :on-change #(qpe-dispatch [:qpe/universal-target-form-change :port (js/parseInt (.. % -target -value))])}]
    [form/form-control-feedback {:type "invalid"} "Please provide the target IP address"]]])

(defn websocket-fields [{:keys [pending? qpe-dispatch ut]}]
  (let [websocket-auth-type (:WebsocketAuthorizationType ut)
        basic-auth-type? (= websocket-auth-type "basic")
        bearer-auth-type? (= websocket-auth-type "bearer")]
  [:<>
   [:div.mb-3
    [form/form-label "Websocket scheme *"]
    [form/form-select
     {:disabled  pending?
      :required  true
      :value     (or (:WebsocketScheme ut) "")
      :on-change #(qpe-dispatch [:qpe/universal-target-form-change :WebsocketScheme (.. % -target -value)])}
     (for [scheme ["ws" "wss"]]
       [:option
        {:key   scheme
         :value scheme}
        (str/upper-case scheme)])]]
   [:div.mb-3
    [form/form-label "Websocket address *"]
    [form/form-control
     {:disabled    pending?
      :placeholder  "<hostname-or-ip>:<port>/<path>"
      :default-value       (or (:WebsocketAddress ut) "")
      :on-change   #(qpe-dispatch [:qpe/universal-target-form-change :WebsocketAddress (.. % -target -value)])}]]

   [:div.mb-3
    [form/form-label "Auth Type"]
    [form/form-select
     {:disabled  pending?
      :value     (or (:WebsocketAuthorizationType ut) "")
      :on-change #(qpe-dispatch [:qpe/universal-target-form-change :WebsocketAuthorizationType (.. % -target -value)])}
     [:option {:value "none"} "None"]
     [:option {:value "basic"} "BASIC username/password"]
     [:option {:value "bearer"} "BEARER token"]]]

   (when basic-auth-type?
     [:div.mb-3
      [form/form-label "Username"]
      [form/form-control
       {:disabled  pending?
        :default-value     (or (:WebsocketUsername ut) "")
        :on-change #(qpe-dispatch [:qpe/universal-target-form-change :WebsocketUsername (.. % -target -value)])}]])
   (when basic-auth-type?
     [:div.mb-3
      [form/form-label "Password"]
      [form/form-control
       {:type      "password"
        :disabled  pending?
        :default-value     (or (:WebsocketPassword ut) "")
        :on-change #(qpe-dispatch [:qpe/universal-target-form-change :WebsocketPassword (.. % -target -value)])}]])
   (when bearer-auth-type?
     [:div.mb-3
      [form/form-label "Websocket AuthToken"]
      [form/form-control
       {:disabled  pending?
        :default-value     (or (:WebsocketAuthToken ut) "")
        :on-change #(qpe-dispatch [:qpe/universal-target-form-change :WebsocketAuthToken (.. % -target -value)])}]])]))

(defn valid-headers? [val]
  (or (empty? val)
      (re-matches #"\s*(\"[^\"]*\"\s*=\s*\"[^\"]*\"\s*)(,\s*\"[^\"]*\"\s*=\s*\"[^\"]*\"\s*)*" val)))

(defn find-invalid-chars [s allowed-pattern]
  (let [invalid (->> s
                     (filter #(not (re-matches allowed-pattern (str %))))
                     distinct)]
    (when (seq invalid)
      (apply str invalid))))

(defn find-header-key-invalid-chars [s]
  (find-invalid-chars s #"[a-zA-Z0-9\-_]"))

(defn find-header-value-invalid-chars [s]
  (find-invalid-chars s #"[a-zA-Z0-9_.,;:\\/'?!()\[\]{}@<>=\-+*#$&|~^% `]"))

(defn find-invalid-url-chars [s]
  (find-invalid-chars s #"[a-zA-Z0-9\-._~!#$&'()*+,/:;=?@\[\]% ]"))

(defn http-post-fields [{:keys [pending? qpe-dispatch ut control-type?]}]
  (let [url-state (r/atom {:url-empty?          (empty? (or (:url ut) ""))
                           :url-invalid-scheme? false
                           :url-invalid-chars   nil
                           :url-touched?        false
                           :headers-invalid?    false
                           :headers-key-invalid-chars nil
                           :headers-value-invalid-chars nil})]
    (fn [{:keys [pending? qpe-dispatch ut]}]
      (let [{:keys [url-empty? url-invalid-scheme? url-invalid-chars headers-invalid? url-touched?
                    headers-key-invalid-chars headers-value-invalid-chars]} @url-state
            on-url-change (fn [e]
                            (let [val (.. e -target -value)]
                              (swap! url-state assoc
                                     :url-touched?        true
                                     :url-empty?          (empty? val)
                                     :url-invalid-scheme? (and (seq val)
                                                               (not (re-matches #"https?://.*" val)))
                                     :url-invalid-chars   (when (seq val)
                                                            (find-invalid-url-chars val)))
                              (qpe-dispatch [:qpe/universal-target-form-change :url val])))
            on-headers-change (fn [e]
                                (let [val (.. e -target -value)
                                      quoted-parts (map second (re-seq #"\"([^\"]*)\"" val))
                                      keys   (keep-indexed #(when (even? %1) %2) quoted-parts)
                                      values (keep-indexed #(when (odd? %1) %2) quoted-parts)
                                      key-invalid   (->> keys
                                                         (mapcat #(or (find-header-key-invalid-chars %) []))
                                                         distinct
                                                         seq)
                                      value-invalid (->> values
                                                         (mapcat #(or (find-header-value-invalid-chars %) []))
                                                         distinct
                                                         seq)]
                                  (swap! url-state assoc
                                         :headers-invalid?            (not (valid-headers? val))
                                         :headers-key-invalid-chars   (when key-invalid (apply str key-invalid))
                                         :headers-value-invalid-chars (when value-invalid (apply str value-invalid)))
                                  (qpe-dispatch [:qpe/universal-target-form-change :headers val])))]
        [:<>
         [:div.mb-3
          [form/form-label "URL *"]
          [form/form-control
           {:disabled      (or pending? control-type?)
            :placeholder   "https://"
            :required      true
            :class         (when (and url-touched? (or url-empty? url-invalid-scheme? url-invalid-chars)) "is-invalid")
            :default-value (or (:url ut) "")
            :on-change     on-url-change}]
          (when (and url-touched? url-empty?)
            [form/form-control-feedback {:type "invalid"} "URL cannot be empty"])
          (when url-invalid-scheme?
            [form/form-control-feedback {:type "invalid"} "Invalid scheme, has to start with http:// or https://"])
          (when url-invalid-chars
            [form/form-control-feedback {:type "invalid"} (str "Invalid URL, contains unallowed characters: " url-invalid-chars)])]

         [:div.mb-3
          [form/form-label "Headers (\"key1\" = \"value1\", \"key2\" = \"value2\",...)"]
          [form/form-control
           {:disabled      (or pending? control-type?)
            :placeholder   "\"Content-Type\" = \"application/json\", \"Cache-Control\" = \"no-cache\""
            :class         (when (or headers-invalid? headers-key-invalid-chars headers-value-invalid-chars) "is-invalid")
            :default-value (or (:headers ut) "")
            :on-change     on-headers-change}]
          (when headers-invalid?
            [form/form-control-feedback {:type "invalid"} "Failed to parse headers. Check formatting."])

          (when headers-key-invalid-chars
            [form/form-control-feedback {:type "invalid"}
             (str "Failed to parse headers. Key contains unallowed characters: " headers-key-invalid-chars)])
          (when headers-value-invalid-chars
            [form/form-control-feedback {:type "invalid"}
             (str "Failed to parse headers. Value contains unallowed characters: " headers-value-invalid-chars)])]]))))

(defn universal-target-form [target-mode ut {:keys [qpe-dispatch qpe-subscribe form-type pending?]} qpe]
  (let [error @(qpe-subscribe [:qpe/data :ui :sidebar :ut :errors])
        control-type? (= :control form-type)
        site-resource-id @(qpe-subscribe [:qsm/siteresource])
        site-plan-key @(qpe-subscribe [:qpe/data :current-project :license-uuid])
        qpe-version (:version qpe)
        version-first-digits (subs (str qpe-version) 0 3)
        latest-qpe-version? (if (number? version-first-digits)
                              (>= version-first-digits 9.3)
                              (>= (parse-double version-first-digits) 9.3))
        trigger-mode-interval? (= "interval" (:triggerMode ut))
        trigger-mode-options (if latest-qpe-version?
                               [:<>
                                (concat [[:option {:value "" :key "empty-trigger-mode"} ""]
                                         [:option {:value "lastseenupdate" :key "lastseenupdate" } "Last seen update"]
                                         [:option {:value "interval" :key "interval"} "Interval"]
                                         [:option {:value "rawpositionupdate" :key "rawpositionupdate"} "Raw position update"]
                                         [:option {:value "smoothpositionupdate" :key "smoothpositionupdate"} "Smooth position update"]
                                         [:option {:value "kalmanpositionupdate" :key "kalmanpositionupdate"} "Kalman position update"]
                                         [:option {:value "locationupdate" :key "locationupdate" } "Location update"]
                                         [:option {:value "buttondownupdate" :key "buttondownupdate"} "Button down update"]]
                                        (when control-type?
                                          [[:option {:value "positionupdate" :key "positionupdate"} "Position update"]
                                           [:option {:value "calculationupdate" :key "calculationupdate"} "Calculation update"]]))]
                               [:<>
                                [:option {:value "" :key "empty-trigger-mode"} ""]
                                [:option {:value "interval" :key "interval"} "Interval"]
                                [:option {:value "positionupdate" :key "positionupdate"} "Position update"]
                                [:option {:value "anydataupdate" :key "anydataupdate"} "Any data update"]])]

  [:<>
   [:div.mb-3
    [form/form-label "Name *"]
    [form/form-control
     {:required    true
      :type        "text"
      :disabled    (or control-type? pending?)
      :default-value (or (:name ut) "")
      :on-change    #(qpe-dispatch [:qpe/universal-target-form-change :name (.. % -target -value)])}]
    [form/form-control-feedback {:type "invalid"} "Please provide the name"]]

   [:div.mb-3
    [form/form-label "Output Format *"]
    [form/form-select
     {:disabled  (or control-type? pending?)
      :required  true
      :default-value (:format ut)
      :on-change #(qpe-dispatch [:qpe/universal-target-form-change :format (.. % -target -value)])}
     [:option ""]
     (for [uf @(qpe-subscribe [:qpe/data :project-state :universal-formats])]
       [:option
        {:key (:id uf)
         :value (:id uf)}
        (:name uf)])]
    [form/form-control-feedback {:type "invalid"} "Please provide the output format"]]

   [:div.mb-3
    [form/form-label "Type *"]
    [form/form-select
     ;; type not in controlOutputTarget API
     {:disabled  (or control-type? pending?)
      :required  true
      :value     (:type ut)
      :on-change #(qpe-dispatch [:qpe/universal-target-form-change :type (.. % -target -value)])}
     [:option {:value "json"} "JSON"]
     [:option {:value "csv"} "CSV"]]
    [form/form-control-feedback {:type "invalid"} "Please provide the type"]]

   [:div.mb-3
    [form/form-label "Trigger mode *"]
    [form/form-select
     {;; TriggerMode can't be changed
      :disabled (or control-type? pending?)
      :required  true
      :value    (:triggerMode ut)
      :on-change #(qpe-dispatch [:qpe/universal-target-form-change :triggerMode (.. % -target -value)])}
     trigger-mode-options]
    [form/form-control-feedback {:type "invalid"} "Please provide the trigger mode"]]

   (when trigger-mode-interval?
     [:div.mb-3
      [form/form-label "Interval [0.1...600s] *"]
      [form/form-control
       {:type      "number"
        :disabled  pending?
        :required  true
        :default-value     (str (:interval ut))
        :on-change #(qpe-dispatch [:qpe/universal-target-form-change :interval (js/parseFloat (.. % -target -value))])}]
      [form/form-control-feedback {:type "invalid"} "Please provide the interval"]])

   (when (= target-mode :File)
     [:div.mb-3
      [form/form-label "Prefix"]
      [form/form-control
       {:type      "text"
        :disabled  pending?
        :default-value     (:prefix ut)
        :on-change #(qpe-dispatch [:qpe/universal-target-form-change :prefix (.. % -target -value)])}]])

   (when latest-qpe-version?
     [:div.mb-3
      [form/form-label "On data change"]
      [form/form-control
       {:type      "text"
        :disabled  pending?
        :default-value (:onDataChange ut)
        :on-change #(qpe-dispatch [:qpe/universal-target-form-change :onDataChange (.. % -target -value)])}]])

   (when trigger-mode-interval?
     [:div.mb-3
      [form/form-label "Max batch size"]
      [form/form-control
       {:type      "number"
        :disabled  pending?
        :default-value     (str (:maxBatchSize ut))
        :on-change #(qpe-dispatch [:qpe/universal-target-form-change :maxBatchSize (js/parseFloat (.. % -target -value))])}]])

   (when (= target-mode :HTTPPost)
     [http-post-fields {:pending? pending?
                        :qpe-dispatch qpe-dispatch
                        :control-type? control-type?
                        :ut ut}])

   (when (= target-mode :UDP)
     [udp-fields pending? qpe-dispatch ut])
   (when (= target-mode :MQTT)
    [mqtt-fields {:pending? pending?
                  :qpe-dispatch qpe-dispatch
                  :ut ut
                  :site-plan-key site-plan-key
                  :error error
                  :control-type? control-type?
                  :site-resource-id site-resource-id}])
   (when (= target-mode :Websocket)
     [websocket-fields {:pending? pending?
                        :qpe-dispatch qpe-dispatch
                        :ut ut
                        :error error
                        :control-type? control-type?}])]))

